// 📄 pages/Proyectos/components/OrganigramaMiembroModal.tsx
import React, { useState } from 'react';
import { X, Save, RefreshCw } from 'lucide-react';
import { ProjectMember, updateMemberOrganigrama } from '../../../services/projectService.ts';

interface OrganigramaMiembroModalProps {
  projectId: string;
  miembro: ProjectMember;
  cargosDisponibles: string[];
  onClose: () => void;
  onSaved: () => void;
}

export default function OrganigramaMiembroModal({ projectId, miembro, cargosDisponibles, onClose, onSaved }: OrganigramaMiembroModalProps) {
  const [cargo, setCargo] = useState(miembro.cargoOrganigrama || cargosDisponibles[0] || '');
  const [responsabilidades, setResponsabilidades] = useState(miembro.responsabilidades || '');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setGuardando(true);
    try {
      await updateMemberOrganigrama(projectId, miembro.userId, cargo, responsabilidades);
      onSaved();
    } catch (err: any) {
      setError(err.message || 'Error al guardar.');
    } finally {
      setGuardando(false);
    }
  };

  const inputClass = "w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-blue-500";
  const labelClass = "block text-xs font-medium text-gray-400 mb-1";

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-[rgb(var(--c-surface))] border border-white/10 rounded-2xl w-full max-w-md shadow-2xl">
        <div className="flex items-center justify-between p-5 border-b border-white/10">
          <h3 className="text-lg font-medium text-white">Organigrama — {miembro.email}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white"><X className="w-5 h-5" /></button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          {error && <div className="bg-red-500/10 border border-red-500/30 text-red-400 p-3 rounded-lg text-xs">{error}</div>}

          <div>
            <label className={labelClass}>Cargo en el organigrama</label>
            <select value={cargo} onChange={(e) => setCargo(e.target.value)} className={inputClass}>
              {cargosDisponibles.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>

          <div>
            <label className={labelClass}>Responsabilidades / accesos</label>
            <textarea
              value={responsabilidades}
              onChange={(e) => setResponsabilidades(e.target.value)}
              rows={4}
              placeholder="ej. Acceso a Cloud Connector, crea SRs, acceso a BTP..."
              className={inputClass}
            />
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg text-sm text-gray-400 hover:text-white">Cancelar</button>
            <button
              type="submit"
              disabled={guardando}
              className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-500 disabled:opacity-50 px-4 py-2 rounded-lg text-sm font-semibold text-white transition-all"
            >
              {guardando ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
